export default function CarrierShipmnet() {

  return (
      <p>حمل های در حال انجام</p>
  );
};